<template>
  <list
    :columns="columns"
    :modalCreate="modalCreate"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="false"
    :isAdd="false"
    :itemLink="itemLink"
    :setLink="setLink"
    :openItem="false"
    :fields="fields"
    :searchDisable="true"
    @change="change"
    @changeFunction="changeFunction"
    v-model="val"
  />
</template>
<script>
export default {
  name: "products",
  props: ["id"],
  created() {
    //надо получить группу!
    this.itemLink = `business/lessonplans/${this.id}/media`;
    this.setLink = `business/lessonplans/${this.id}/media`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      loadingStatus: null,
      val: [],
      modalCreate: "client_group",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "name",
          title: "Название",
          checkbox: false,
        },
        {
          key: "file_name",
          title: "Название файла",
          checkbox: false,
        },
        {
          key: "path",
        },
        {
          key: "created_at",
          dateTimeFormat: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
